import Color from 'color';
import blendColors from '../utils/blendColors';
import alpha from '../utils/alpha';

import {
  SHADOW_SPREAD_6,
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/shadow_spread';
import {
  NOKIA_PURE_TEXT_BOLD,
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/fontFamily';

import {
  WHITE,
  BLACK
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/colors';

import {
  OPACITY_12,
  OPACITY_06,
  OPACITY_76
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/opacity';

import {
  PRIMARY_GLOBAL_CONTENT,
  SECONDARY_GLOBAL_BASE,
  SECONDARY_GLOBAL_CONTENT,
  SECONDARY_GLOBAL_FOCUS,
  SECONDARY_GLOBAL_BACKGROUND,
  SECONDARY_GLOBAL_HOVER,
  SECONDARY_GLOBAL_DISABLED_CONTENT,
  SECONDARY_GLOBAL_PLACEHOLDER,
  SECONDARY_GLOBAL_PRESSED,
  PRIMARY_GLOBAL_BASE,
  PRIMARY_GLOBAL_FOCUS,
  PRIMARY_GLOBAL_HOVER,
  PRIMARY_GLOBAL_PRESSED,
  PRIMARY_GLOBAL_HYPERLINK,
  PRIMARY_GLOBAL_DISABLED_CONTENT,
  PRIMARY_GLOBAL_DISABLED_BACKGROUND,
  PRIMARY_GLOBAL_TEXT,
  SECONDARY_GLOBAL_PRESSED_CONTENT,
  SECONDARY_GLOBAL_TEXT,
  SECONDARY_GLOBAL_DISABLED_TEXT,
  SECONDARY_GLOBAL_DISABLED_BACKGROUND,
  SECONDARY_GLOBAL_LABEL,
  SECONDARY_GLOBAL_ERROR_TEXT,
  SECONDARY_BUTTON_CONTENT,
  PRIMARY_GLOBAL_ERROR_TEXT,
  LIST_SELECTED,
  CALENDAR_RANGE_TITLE,
  SECONDARY_GLOBAL_DIVIDER,
  INPUT_BORDER,
  DATAGRID_BASE,
  DATAGRID_HOVER,
  DATAGRID_PRESSED,
  DATAGRID_PRESSED_TEXT,
  DATAGRID_FOCUS,

  STATUS_SUCCESS,
  STATUS_CRITICAL,
  STATUS_MAJOR,
  STATUS_MINOR,
  STATUS_CONTENT,
  STATUS_CLEARED,
  STATUS_WARNING,
  STATUS_FAULT,
  STATUS_INSTALLED,
  STATUS_MAJOR_OFF,
  STATUS_MINOR_OFF,
  STATUS_WARNING_OFF,
  STATUS_CRITICAL_OFF,
  STATUS_CRITICAL_ON,
  STATUS_MAJOR_ON,
  STATUS_MINOR_ON,
  STATUS_WARNING_ON,
  STATUS_CRITICAL_DISABLED,
  STATUS_MAJOR_DISABLED,
  STATUS_MINOR_DISABLED,
  STATUS_WARNING_DISABLED,

  DATAGRID_DIVIDER,
  DATAGRID_LABEL,
  DATAGRID_ERROR_BACKGROUND,
  DATAGRID_SELECTED,
  DATAGRID_SELECTED_HOVER,
  DATAGRID_SELECTED_PRESSED,
  DATAGRID_SELECTED_FOCUS,
  DATAGRID_HEADER_BASE,
  DATAGRID_INPUT_BORDER,
  FILEUPLOAD_ACTIVE,
  LIST_ITEM_BASE,
  LIST_ITEM_FOCUS,
  LIST_ITEM_SELECTED_HOVER,
  LIST_ITEM_SELECTED_FOCUS,
  LIST_ITEM_HOVER,
  LIST_BADGE_HOVER_BORDER,
  LIST_ITEM_SELECTED,
  LIST_ITEM_DISABLED,
  LIST_ITEM_PRESSED,
  LIST_ITEM_UNREAD,
  LIST_ITEM_PRESSED_CONTENT,
  LIST_HEADER_BACKGROUND,
  LIST_TEXT_SELECTED,
  LIST_ITEM_ACTIVE,
  STEPFORM_BASE,
  STEPFORM_HOVER,
  STEPFORM_PRESSED,
  STEPFORM_ERROR_BACKGROUND,
  STEPFORM_SELECTED_BACKGROUND,
  STEPFORM_SELECTED_HOVER,
  STEPFORM_SELECTED_TEXT,
  STEPFORM_ACTIVE,
  STEPFORM_COMPLETED_DISABLED,
  STEPFORM_FUTURE,
  STEPFORM_WARNING,
  STEPFORM_DISABLED_WARNING_ICON,
  STEPFORM_ERROR_ICON,
  STEPFORM_PRESSED_ERROR_ICON,
  STEPFORM_DISABLED_ERROR_ICON,
  STEPFORM_TEXT,
  STEPFORM_PRESSED_TEXT,
  TABS_BASE,
  TABS_HOVER,
  TABS_HOVER_SOLID,
  TABS_PRESSED,
  TABS_PRESSED_TEXT,
  TEXT_SELECTION,
  TEXT_SELECTION_FOCUS,
  TREE_BASE,
  TREE_HOVER,
  TREE_SELECTED,
  TREE_SELECTED_HOVER,
  TREE_DISABLED,
  EXPANSION_PANEL_BASE,
  EXPANSION_PANEL_SELECTED_HOVER,
  EXPANSION_PANEL_HOVER,
  EXPANSION_PANEL_SELECTED,
  EXPANSION_PANEL_DISABLED,
  EXPANSION_PANEL_PRESSED,
  CTA_DISABLED_CONTENT,
  CHIP_BASE,
  CHIP_CONTENT,
  CHIP_SECONDARY_CONTENT,
  CHIP_ICON,
  CHIP_FOCUS,
  CHIP_HOVER,
  CHIP_PRESSED,
  CHIP_DISABLED,
  CHIP_DISABLED_CONTENT,
  CHIP_SELECTED,
  CHIP_SELECTED_HOVER,
  CHIP_SELECTED_FOCUS,
  CHIP_INFO,
  CHIP_ERROR_BACKGROUND,
  CHIP_ERROR_SELECTED_BACKGROUND,
  CHIPS_PRIMARY_FOCUS,

  HYPERLINK_DISABLED,
  HYPERLINK_PRESSED,

  INPUT_HOVER,
  SLIDER_TRACK,
  TOOLTIP_TEXT,
  TOOLTIP_BACKGROUND,

  QUERY_BACKGROUND_ON,
  QUERY_BACKGROUND_FOCUS,

  TOGGLE_GROUP_HOVER_ON,
  PROGRESS_INDICATOR,
  PROGRESS_INDICATOR_TRACK,
  PROGRESS_INDICATOR_DETERMINATE,
  AVATAR_LIGHTBLUE,
  AVATAR_CONTENT,
  AVATAR_ORANGE,
  AVATAR_YELLOW,
  AVATAR_BLUE,
  AVATAR_GREEN,
  APPBANNER_PRIMARY_FOCUS,
  APPBANNER_PRIMARY_CONTENT,
  APPBANNER_SECONDARY_CONTENT,
  APPBANNER_BACKGROUND,
  APPBANNER_BADGE_HOVER_BORDER,
  APPBANNER_BADGE_PPRESSED_BORDER,
  APPBANNER_DIVIDER,
  APPBANNER_BADGE,
  APPBANNER_SHADOW_SPREAD,
  APPBANNER_PRESSED,

  GLOBAL_TRANSPARENT,
  CLI_BACKGROUND,
  CLI_TEXT,
  CLI_BACKGROUND_TEXT,
  CLI_CURSOR,
  CLI_ICON,
  CLI_BACKGROUND_PAG,
  SNACKBAR_BACKGROUND,
  SNACKBAR_TEXT,
  SNACKBAR_HYPERLINK,
  SNACKBAR_PROGRESS_INDICATOR_DETERMINATE,
  SNACKBAR_PROGRESS_INDICATOR,
  FEEDBACK_INFO_BACKGROUND,
  FEEDBACK_ERROR_BACKGROUND,
  FEEDBACK_WARNING_BACKGROUND,
  FEEDBACK_SUCCESS_BACKGROUND,
  FEEDBACK_HYPERLINK,
  FEEDBACK_OVERLAY,
  FEEDBACK_SUCCESS,
  OVERLAY_TOP_DIVIDER,
  TOGGLEGROUP_BACKGROUND_ON,
  TOGGLEGROUP_HOVER_ON,
  TOGGLEGROUP_DIVIDER_ON,
  TOGGLEGROUP_CONTENT_ON,
  TOGGLEGROUP_CONTENT_OFF,
  TOGGLEGROUP_CONTENT_PRESSED_ON,
  TOGGLEGROUP_CONTENT_PRESSED_OFF,
  TOGGLE_CONTENT_ON,
  TOGGLE_BACKGROUND_ON,
  TOGGLE_FOCUS_ON,
  OR_TOGGLE_BACKGROUND,
  FAB_PRIMARY_BACKGROUND ,
  FAB_CONTENT,
  FAB_PRIMARY_FOCUS ,
  FAB_HOVER,
  FAB_PRESSED,
  FAB_SECONDARY_BACKGROUND,
  FAB_CLOSE_BACKGROUND,
  FAB_CLOSE_CONTENT,
  FAB_MINI_BACKGROUND,
  SWITCH_PRIMARY_OFF_TRACK,
  SWITCH_PRIMARY_OFF_KNOB,
  SWITCH_PRIMARY_OFF_HOVER,
  SWITCH_PRIMARY_OFF_PRESSED,
  SWITCH_PRIMARY_OFF_DISABLED_KNOB,
  SWITCH_PRIMARY_ON_TRACK,
  SWITCH_PRIMARY_ON_KNOB,
  SWITCH_PRIMARY_ON_HOVER,
  SWITCH_PRIMARY_ON_PRESSED,
  SWITCH_PRIMARY_ON_DISABLED_KNOB,
  SWITCH_SECONDARY_OFF_TRACK,
  SWITCH_SECONDARY_OFF_KNOB,
  SWITCH_SECONDARY_OFF_HOVER,
  SWITCH_SECONDARY_OFF_PRESSED,
  SWITCH_SECONDARY_OFF_DISABLED_KNOB,
  SWITCH_SECONDARY_ON_TRACK,
  SWITCH_SECONDARY_ON_KNOB,
  SWITCH_SECONDARY_ON_HOVER,
  SWITCH_SECONDARY_ON_PRESSED,
  SWITCH_SECONDARY_ON_DISABLED_KNOB,
  BADGE_BLUE,
  BADGE_GREEN,
  BADGE_GREY,
  BREADCRUMB_PRESSED_CONTENT,
  EXPRESSION_NORMAL,
  EXPRESSION_FOCUS,
  CHECKBOX_CHECKED,
  RADIOBUTTON_CHECKED,
  STATUSBAR_INPUT_BORDER,
  STICKY_HEADER,
  STICKY_HEADER_HOVER,
  STICKY_HEADER_ACTIVE,
  NAV_CLOSE_CONTENT,
  NAV_CLOSE_HOVER,
  NOKIA_LOGO_BLUE,
  NOKIA_LOGO_WHITE,
  BACKGROUND_0,
  BACKGROUND_1,
  BACKGROUND_2,
  BACKGROUND_3,
  BACKGROUND_4,
  BACKGROUND_6,
  BACKGROUND_8,
  BACKGROUND_9,
  BACKGROUND_12,
  BACKGROUND_16,
  BACKGROUND_24,
  BACKGROUND_0_DARK,
  BACKGROUND_1_DARK,
  BACKGROUND_2_DARK,
  BACKGROUND_3_DARK,
  BACKGROUND_4_DARK,
  BACKGROUND_6_DARK,
  BACKGROUND_8_DARK,
  BACKGROUND_9_DARK,
  BACKGROUND_12_DARK,
  BACKGROUND_16_DARK,
  BACKGROUND_24_DARK,
  SHADOW_1,
  SHADOW_2,
  SKELETON_BASE,
  SKELETON_GRADIENT,
} from '../global-colors/global-colors-aaa-default-theme';

const NAME = 'aaa-default';

const GLOBAL_CCFK_STYLE = {
  background: WHITE
};

const BUTTON = {
  // "secondary" or "default" variant
  FLAT: {
    content: SECONDARY_BUTTON_CONTENT,
    container: SECONDARY_GLOBAL_BACKGROUND,
    border: GLOBAL_TRANSPARENT,
    rippleColor: SECONDARY_GLOBAL_PRESSED,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS
    },
    hovered: {
      container: blendColors(SECONDARY_GLOBAL_BACKGROUND, SECONDARY_GLOBAL_HOVER)
    },
    disabled: {
      content: SECONDARY_GLOBAL_DISABLED_CONTENT,
      container: SECONDARY_GLOBAL_BACKGROUND
    }
  },
  // "outlined" variant
  OUTLINED: {
    content: SECONDARY_BUTTON_CONTENT,
    container: SECONDARY_GLOBAL_BACKGROUND,
    border: SECONDARY_BUTTON_CONTENT,
    rippleColor: SECONDARY_GLOBAL_PRESSED,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS
    },
    hovered: {
      container: blendColors(SECONDARY_GLOBAL_BACKGROUND, SECONDARY_GLOBAL_HOVER)
    },
    disabled: {
      content: SECONDARY_GLOBAL_DISABLED_CONTENT,
      border: SECONDARY_GLOBAL_DISABLED_CONTENT,
      container: SECONDARY_GLOBAL_BACKGROUND
    }
  },
  // "call-to-action" variant
  CTA: {
    content: PRIMARY_GLOBAL_CONTENT,
    container: PRIMARY_GLOBAL_BASE,
    border: GLOBAL_TRANSPARENT,
    rippleColor: PRIMARY_GLOBAL_PRESSED,
    focused: {
      border: SECONDARY_GLOBAL_FOCUS
    },
    hovered: {
      container: blendColors(PRIMARY_GLOBAL_BASE, PRIMARY_GLOBAL_HOVER)
    },
    disabled: {
      content: CTA_DISABLED_CONTENT,
      container: PRIMARY_GLOBAL_DISABLED_BACKGROUND
    },
  },
  TOGGLE: {
    content: TOGGLE_CONTENT_ON,
    container: TOGGLE_BACKGROUND_ON,
    border: GLOBAL_TRANSPARENT,
    rippleColor: PRIMARY_GLOBAL_PRESSED,
    focused: {
      border: TOGGLE_FOCUS_ON,
    },
    hovered: {
      container: blendColors(TOGGLE_BACKGROUND_ON, PRIMARY_GLOBAL_HOVER)
    },
    disabled: {
      content: CTA_DISABLED_CONTENT,
      container: PRIMARY_GLOBAL_DISABLED_BACKGROUND
    },
  }
};

const ICON = {
  color: SECONDARY_GLOBAL_CONTENT,
};

const ICON_BUTTON = {
  FLAT: {
    content: SECONDARY_GLOBAL_CONTENT,
    container: SECONDARY_GLOBAL_BACKGROUND,
    border: GLOBAL_TRANSPARENT,
    rippleColor: SECONDARY_GLOBAL_PRESSED,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS,
      content: SECONDARY_GLOBAL_PRESSED_CONTENT
    },
    hovered: {
      content: SECONDARY_GLOBAL_PRESSED_CONTENT,
      container: blendColors(SECONDARY_GLOBAL_BACKGROUND, SECONDARY_GLOBAL_HOVER)
    },
    disabled: {
      content: SECONDARY_GLOBAL_DISABLED_CONTENT,
      container: SECONDARY_GLOBAL_BACKGROUND
    }
  },
  CTA: BUTTON.CTA,
  TOGGLE: {
    ...BUTTON.TOGGLE,
    critical: {
      on: STATUS_CRITICAL_ON,
      off: STATUS_CRITICAL_OFF,
    }
  }
};


const ELEVATIONS = {
  0: {
    lightBackgroundColor: BACKGROUND_0,
    darkBackgroundColor: BACKGROUND_0_DARK,
    shadowColorOne: GLOBAL_TRANSPARENT,
    shadowColorTwo: GLOBAL_TRANSPARENT
  },
  1: {
    lightBackgroundColor: BACKGROUND_1,
    darkBackgroundColor: BACKGROUND_1_DARK,
    shadowColorOne: SHADOW_1,
    shadowColorTwo: SHADOW_2
  },
  2: {
    lightBackgroundColor: BACKGROUND_2,
    darkBackgroundColor: BACKGROUND_2_DARK,
    shadowColorOne: SHADOW_1,
    shadowColorTwo: SHADOW_2
  },
  3: {
    lightBackgroundColor: BACKGROUND_3,
    darkBackgroundColor: BACKGROUND_3_DARK,
    shadowColorOne: SHADOW_1,
    shadowColorTwo: SHADOW_2
  },
  4: {
    lightBackgroundColor: BACKGROUND_4,
    darkBackgroundColor: BACKGROUND_4_DARK,
    shadowColorOne: SHADOW_1,
    shadowColorTwo: SHADOW_2
  },
  6: {
    lightBackgroundColor: BACKGROUND_6,
    darkBackgroundColor: BACKGROUND_6_DARK,
    shadowColorOne: SHADOW_1,
    shadowColorTwo: SHADOW_2
  },
  8: {
    lightBackgroundColor: BACKGROUND_8,
    darkBackgroundColor: BACKGROUND_8_DARK,
    shadowColorOne: SHADOW_1,
    shadowColorTwo: SHADOW_2
  },
  9: {
    lightBackgroundColor: BACKGROUND_9,
    darkBackgroundColor: BACKGROUND_9_DARK,
    shadowColorOne: SHADOW_1,
    shadowColorTwo: SHADOW_2
  },
  12: {
    lightBackgroundColor: BACKGROUND_12,
    darkBackgroundColor: BACKGROUND_12_DARK,
    shadowColorOne: SHADOW_1,
    shadowColorTwo: SHADOW_2
  },
  16: {
    lightBackgroundColor: BACKGROUND_16,
    darkBackgroundColor: BACKGROUND_16_DARK,
    shadowColorOne: SHADOW_1,
    shadowColorTwo: SHADOW_2
  },
  24: {
    lightBackgroundColor: BACKGROUND_24,
    darkBackgroundColor: BACKGROUND_24_DARK,
    shadowColorOne: SHADOW_1,
    shadowColorTwo: SHADOW_2
  }
};

const TOOLTIP = {
  container: TOOLTIP_BACKGROUND,
  content: TOOLTIP_TEXT,
  richContainer: ELEVATIONS['2'].lightBackgroundColor,
  richContent: SECONDARY_GLOBAL_TEXT,
};

const APP_BANNER = {
  background: APPBANNER_BACKGROUND,
  logo: PRIMARY_GLOBAL_CONTENT,
  primaryContent: APPBANNER_PRIMARY_CONTENT,
  divider: APPBANNER_DIVIDER,
  secondaryContent: APPBANNER_SECONDARY_CONTENT,
  shadowColorOne: ELEVATIONS['4'].shadowColorOne,
  shadowColorTwo: ELEVATIONS['4'].shadowColorTwo,
  shadowSpread: APPBANNER_SHADOW_SPREAD
};

const APP_BANNER_INTERACTIVE_CONTENT = {
  background: GLOBAL_TRANSPARENT,
  content: APPBANNER_PRIMARY_CONTENT,
  border: GLOBAL_TRANSPARENT,
  focused: {
    background: GLOBAL_TRANSPARENT,
    content: APPBANNER_PRIMARY_CONTENT,
    border: APPBANNER_SECONDARY_CONTENT,
  },
  hovered: {
    background: PRIMARY_GLOBAL_HOVER,
    content: APPBANNER_PRIMARY_CONTENT,
    border: GLOBAL_TRANSPARENT
  },
  pressed: {
    background: APPBANNER_PRESSED,
  },
  badge: APPBANNER_BADGE,
  badgeHoveredBorder: APPBANNER_BADGE_HOVER_BORDER,
  badgePressed: APPBANNER_BADGE_PPRESSED_BORDER,
};

const HORIZONTAL_NAVIGATION = {
  background: APPBANNER_BACKGROUND,
  content: SECONDARY_GLOBAL_BASE,
  notification: STATUS_CRITICAL,
  off: {
    background: APPBANNER_BACKGROUND,
    content: APPBANNER_SECONDARY_CONTENT,
    hovered: {
      content: APPBANNER_SECONDARY_CONTENT,
      background: blendColors( APPBANNER_BACKGROUND, PRIMARY_GLOBAL_HOVER),
    },
    focused: {
      content: APPBANNER_SECONDARY_CONTENT,
      background: APPBANNER_BACKGROUND,
      border: APPBANNER_PRIMARY_FOCUS,
      hovered: {
        content: APPBANNER_SECONDARY_CONTENT,
        background: blendColors( APPBANNER_BACKGROUND, PRIMARY_GLOBAL_HOVER),
        border: APPBANNER_PRIMARY_FOCUS,
        // @ts-expect-error - TODO: check this, blendColors only blends first two colors
        pressed: blendColors(PRIMARY_GLOBAL_PRESSED, PRIMARY_GLOBAL_HOVER, APPBANNER_BACKGROUND),
      },
      pressed: blendColors(APPBANNER_BACKGROUND, PRIMARY_GLOBAL_PRESSED),
    },
  },
  on: {
    background: APPBANNER_BACKGROUND,
    content: APPBANNER_PRIMARY_CONTENT,
    pressedText: APPBANNER_SECONDARY_CONTENT, // TABS_PRESSED_TEXT,
    onIndicator: APPBANNER_PRIMARY_CONTENT,
    hovered: {
      content: APPBANNER_PRIMARY_CONTENT,
      background: blendColors(APPBANNER_BACKGROUND, PRIMARY_GLOBAL_HOVER),
      onIndicator: APPBANNER_PRIMARY_CONTENT,
    },
    focused: {
      content: APPBANNER_PRIMARY_CONTENT,
      background: APPBANNER_BACKGROUND,
      border: APPBANNER_PRIMARY_FOCUS,
      onIndicator: APPBANNER_PRIMARY_CONTENT,
      hovered: {
        content: APPBANNER_PRIMARY_CONTENT,
        background: blendColors(APPBANNER_BACKGROUND, PRIMARY_GLOBAL_HOVER),
        border: APPBANNER_PRIMARY_FOCUS,
        onIndicator: APPBANNER_PRIMARY_CONTENT,
        pressed: {
          content: APPBANNER_PRIMARY_CONTENT,
          // @ts-expect-error - TODO: check this, blendColors only blends first two colors
          background: blendColors(PRIMARY_GLOBAL_PRESSED, APPBANNER_SECONDARY_CONTENT, APPBANNER_BACKGROUND),
          border: APPBANNER_PRIMARY_FOCUS,
          onIndicator: APPBANNER_PRIMARY_CONTENT,
        }
      },
      pressed: {
        content: APPBANNER_PRIMARY_CONTENT,
        background: blendColors(APPBANNER_BACKGROUND, PRIMARY_GLOBAL_PRESSED),
        border: APPBANNER_PRIMARY_FOCUS,
        onIndicator: APPBANNER_PRIMARY_CONTENT,
      },
    },
  },
  disabled: {
    content: APPBANNER_DIVIDER,
    background: APPBANNER_BACKGROUND,
  },
  closeButton: { // use the ICON_BUTTON dark theme colors
    hover: blendColors(GLOBAL_TRANSPARENT, alpha(NAV_CLOSE_CONTENT, OPACITY_12)),
    content: NAV_CLOSE_CONTENT,
    hovered: {
      content: NAV_CLOSE_HOVER,
    },
  },
};

const HORIZONTAL_NAVIGATION_TAB = {
  navigation: {...HORIZONTAL_NAVIGATION},
  off: {
    background: TABS_BASE,
    content: SECONDARY_GLOBAL_CONTENT,
    onIndicator: GLOBAL_TRANSPARENT,
    border: GLOBAL_TRANSPARENT,
    hovered: {
      content: SECONDARY_GLOBAL_CONTENT,
      background: TABS_HOVER,
      onIndicator: SECONDARY_GLOBAL_DIVIDER,
    },
    focused: {
      content: SECONDARY_GLOBAL_CONTENT,
      background: TABS_BASE,
      border: PRIMARY_GLOBAL_FOCUS,
      onIndicator: SECONDARY_GLOBAL_DIVIDER,
      pressed: TABS_PRESSED,
      hovered: {
        content: SECONDARY_GLOBAL_CONTENT,
        background: TABS_HOVER,
        border: PRIMARY_GLOBAL_FOCUS,
        onIndicator: SECONDARY_GLOBAL_DIVIDER,
        pressed: blendColors(TABS_PRESSED, TABS_HOVER),
      },
    },
  },
  on: {
    background: TABS_BASE,
    content: PRIMARY_GLOBAL_BASE,
    onIndicator: PRIMARY_GLOBAL_BASE,
    border: GLOBAL_TRANSPARENT,
    pressedText: SECONDARY_GLOBAL_CONTENT, // TABS_PRESSED_TEXT,
    hovered: {
      content: PRIMARY_GLOBAL_BASE,
      background: TABS_HOVER,
    },
    focused: {
      content: PRIMARY_GLOBAL_BASE,
      border: PRIMARY_GLOBAL_FOCUS,
      background: TABS_BASE,
      pressed: TABS_PRESSED,
      hovered: {
        content: PRIMARY_GLOBAL_BASE,
        border: PRIMARY_GLOBAL_FOCUS,
        background: TABS_HOVER,
        pressed: blendColors(TABS_PRESSED, TABS_HOVER),
      }
    },
  },
  disabled: {
    content: SECONDARY_GLOBAL_DISABLED_CONTENT,
    background: SECONDARY_GLOBAL_BACKGROUND,
    onIndicator: SECONDARY_GLOBAL_DIVIDER,
  },
  closeButton: {
    hover: TABS_HOVER_SOLID,
  },
  notification: STATUS_CRITICAL,
  bottomBorder: SECONDARY_GLOBAL_DIVIDER,
};

const TOOLBAR = {
  background: SECONDARY_GLOBAL_BACKGROUND, //for Tabs in Toolbar
  primaryContent: SECONDARY_GLOBAL_TEXT,
  secondaryContent: SECONDARY_GLOBAL_LABEL,
};

const LIST = {
  VERTICAL: {
    icon: SECONDARY_GLOBAL_CONTENT,
    text: SECONDARY_GLOBAL_TEXT,
    secondaryText: SECONDARY_GLOBAL_CONTENT,
    hintText: SECONDARY_GLOBAL_DISABLED_CONTENT,
    title: SECONDARY_GLOBAL_LABEL,
    groupHeading: SECONDARY_GLOBAL_LABEL,
    background: LIST_ITEM_BASE,
    headerBackground: LIST_HEADER_BACKGROUND,
    divider: SECONDARY_GLOBAL_DIVIDER,
    disabled: {
      background: LIST_ITEM_DISABLED,
      icon: SECONDARY_GLOBAL_DISABLED_CONTENT,
      text: SECONDARY_GLOBAL_DISABLED_CONTENT
    },
    focused: {
      background: LIST_ITEM_BASE,
      border: PRIMARY_GLOBAL_FOCUS,
    },
    hovered: {
      background: LIST_ITEM_HOVER,
      badgeBackground: '#EBEBEB', // for badge border
      focused: {
        background: LIST_ITEM_HOVER
      }
    },
    selected: {
      background: LIST_ITEM_SELECTED,
      focused: {
        background: LIST_ITEM_SELECTED,
        border: PRIMARY_GLOBAL_FOCUS,
      },
      hovered: {
        background: blendColors(LIST_ITEM_SELECTED, LIST_ITEM_SELECTED_HOVER)
      }
    },
    notification: {
      new: LIST_ITEM_UNREAD,
      title: SECONDARY_GLOBAL_TEXT, 
    },
    sidedrawer: {
      text: SECONDARY_GLOBAL_TEXT,
      selected: LIST_TEXT_SELECTED,
      groupHeading: SECONDARY_GLOBAL_LABEL,
      badge: {
        hover: {
          border: LIST_BADGE_HOVER_BORDER,
        }
      },
      selectedVerticalBar: LIST_TEXT_SELECTED,
      activeVerticalbar: LIST_ITEM_ACTIVE,
    }
  },
  HORIZONTAL: {}
};

const TREE = {
  icon: SECONDARY_GLOBAL_CONTENT,
  text: SECONDARY_GLOBAL_TEXT,
  filterText: SECONDARY_GLOBAL_TEXT,
  title: SECONDARY_GLOBAL_LABEL,
  divider: SECONDARY_GLOBAL_DIVIDER,
  background: TREE_BASE,
  disabled: {
    background: TREE_DISABLED,
    icon: SECONDARY_GLOBAL_DISABLED_CONTENT,
    text: SECONDARY_GLOBAL_DISABLED_CONTENT,
  },
  focused: {
    background: GLOBAL_TRANSPARENT,
    border: PRIMARY_GLOBAL_FOCUS,
  },
  hovered: {
    background: TREE_HOVER,
    focused: {
      background: TREE_HOVER,
      border: PRIMARY_GLOBAL_FOCUS,
    }
  },
  selected: {
    background: TREE_SELECTED,
    focused: {
      background: TREE_SELECTED,
      border: PRIMARY_GLOBAL_FOCUS,
    },
    hovered: {
      background: blendColors(TREE_SELECTED, TREE_SELECTED_HOVER),
    },
  },
  searchResult: {
    background: TREE_SELECTED,
  },
  drag: {
    border: PRIMARY_GLOBAL_FOCUS,
    background: TREE_SELECTED,
    lineColor: PRIMARY_GLOBAL_FOCUS,
    spreadingValue: SHADOW_SPREAD_6,
    shadowColorOne: ELEVATIONS['6'].shadowColorOne,
    shadowColorTwo: ELEVATIONS['6'].shadowColorTwo,
  },
  error: {
    border: SECONDARY_GLOBAL_ERROR_TEXT,
  },
};

const TEXT_INPUT = {
  OUTLINED: {
    background: SECONDARY_GLOBAL_BASE,
    content: SECONDARY_GLOBAL_TEXT,
    border: INPUT_BORDER,
    placeholder: SECONDARY_GLOBAL_PLACEHOLDER,
    dropdownIcon: SECONDARY_GLOBAL_PLACEHOLDER,
    textSelection: TEXT_SELECTION,
    icon: SECONDARY_GLOBAL_CONTENT,
    caret: SECONDARY_GLOBAL_TEXT,
    disabled: {
      background: SECONDARY_GLOBAL_DISABLED_BACKGROUND,
      content: SECONDARY_GLOBAL_DISABLED_CONTENT,
      placeholder: SECONDARY_GLOBAL_PLACEHOLDER,
      border: SECONDARY_GLOBAL_DIVIDER,
      icon: SECONDARY_GLOBAL_DISABLED_CONTENT
    },
    readOnly: {
      background: SECONDARY_GLOBAL_BASE,
      color: SECONDARY_GLOBAL_TEXT,
      content: SECONDARY_GLOBAL_TEXT,
      border: GLOBAL_TRANSPARENT
    },
    focused: {
      border: PRIMARY_GLOBAL_FOCUS,
    },
    hover: {
      border:  blendColors(INPUT_BORDER, INPUT_HOVER),
      placeholder: SECONDARY_GLOBAL_PLACEHOLDER
    },
    error: {
      border: SECONDARY_GLOBAL_ERROR_TEXT
    }
  },
  UNDERLINED: {
    background: SECONDARY_GLOBAL_BACKGROUND,
    content: SECONDARY_GLOBAL_TEXT,
    border: INPUT_BORDER,
    placeholder: SECONDARY_GLOBAL_PLACEHOLDER,
    dropdownIcon: SECONDARY_GLOBAL_PLACEHOLDER,
    textSelection: TEXT_SELECTION,
    icon: SECONDARY_GLOBAL_CONTENT,
    caret: SECONDARY_GLOBAL_TEXT,
    disabled: {
      background: SECONDARY_GLOBAL_BACKGROUND,
      content: SECONDARY_GLOBAL_DISABLED_CONTENT,
      placeholder: SECONDARY_GLOBAL_PLACEHOLDER,
      border: SECONDARY_GLOBAL_DIVIDER,
      icon: SECONDARY_GLOBAL_DISABLED_CONTENT
    },
    readOnly: {
      background: GLOBAL_TRANSPARENT,
      content: SECONDARY_GLOBAL_TEXT,
      border: GLOBAL_TRANSPARENT
    },
    focused: {
      border: PRIMARY_GLOBAL_FOCUS
    },
    hover: {
      border: blendColors(INPUT_BORDER, INPUT_HOVER),
      placeholder: SECONDARY_GLOBAL_PLACEHOLDER
    },
    error: {
      border: SECONDARY_GLOBAL_ERROR_TEXT
    }
  },
  ERROR_MSG: SECONDARY_GLOBAL_ERROR_TEXT,
  LABEL: SECONDARY_GLOBAL_LABEL
};

const TEXT_AREA = {
  OUTLINED: {
    background: SECONDARY_GLOBAL_BASE,
    // This 'text' property will be depreciated
    text: SECONDARY_GLOBAL_TEXT,
    content: SECONDARY_GLOBAL_TEXT,
    border: INPUT_BORDER,
    placeholder: SECONDARY_GLOBAL_PLACEHOLDER,
    dropdownIcon: SECONDARY_GLOBAL_PLACEHOLDER,
    textSelection: TEXT_SELECTION,
    caret: SECONDARY_GLOBAL_TEXT,
    disabled: {
      background: SECONDARY_GLOBAL_DISABLED_BACKGROUND,
      content: SECONDARY_GLOBAL_DISABLED_CONTENT,
      border: SECONDARY_GLOBAL_DIVIDER,
      placeholder: SECONDARY_GLOBAL_PLACEHOLDER,
    },
    readOnly: {
      background: SECONDARY_GLOBAL_BASE,
      color: SECONDARY_GLOBAL_TEXT,
      border: GLOBAL_TRANSPARENT
    },
    focused: {
      border: PRIMARY_GLOBAL_FOCUS,
    },
    hover: {
      border: blendColors(INPUT_BORDER, INPUT_HOVER),
    },
    error: {
      border: SECONDARY_GLOBAL_ERROR_TEXT
    }
  },
  UNDERLINED: {
    background: SECONDARY_GLOBAL_BACKGROUND,
    // This 'text' property will be depreciated
    text: SECONDARY_GLOBAL_TEXT,
    content: SECONDARY_GLOBAL_TEXT,
    border: INPUT_BORDER,
    placeholder: SECONDARY_GLOBAL_PLACEHOLDER,
    dropdownIcon: SECONDARY_GLOBAL_PLACEHOLDER,
    textSelection: TEXT_SELECTION,
    caret: SECONDARY_GLOBAL_TEXT,
    disabled: {
      content: SECONDARY_GLOBAL_DISABLED_CONTENT,
      placeholder: SECONDARY_GLOBAL_PLACEHOLDER,
      border: SECONDARY_GLOBAL_DIVIDER
    },
    readOnly: {
      background: SECONDARY_GLOBAL_BASE,
      content: SECONDARY_GLOBAL_TEXT,
      border: GLOBAL_TRANSPARENT
    },
    focused: {
      border: PRIMARY_GLOBAL_FOCUS,
    },
    hover: {
      border: blendColors(INPUT_BORDER, INPUT_HOVER),
    },
    error: {
      border: SECONDARY_GLOBAL_ERROR_TEXT
    }
  },
  ERROR_MSG: SECONDARY_GLOBAL_ERROR_TEXT,
  LABEL: SECONDARY_GLOBAL_LABEL,
};

const HYPERLINK = {
  normal: PRIMARY_GLOBAL_HYPERLINK,
  focused: PRIMARY_GLOBAL_HYPERLINK,
  hover: PRIMARY_GLOBAL_HYPERLINK,
  pressed: HYPERLINK_PRESSED,
  disabled: HYPERLINK_DISABLED,
  visited: PRIMARY_GLOBAL_HYPERLINK,
};

const AVATAR_FOCUSED = {
  focused: {
    border:  PRIMARY_GLOBAL_FOCUS,
  }
};
const AVATAR_DISABLED = {
  disabled: {
    content: SECONDARY_GLOBAL_DISABLED_CONTENT,
    icon:  SECONDARY_GLOBAL_DISABLED_CONTENT,
    background: SECONDARY_GLOBAL_DISABLED_BACKGROUND,
    imageBackground: PRIMARY_GLOBAL_PRESSED,
    container: SECONDARY_GLOBAL_DISABLED_BACKGROUND,
  }
};

const AVATAR = {
  critical: {
    container: STATUS_CRITICAL,
    content: SECONDARY_GLOBAL_BASE,
    hovered: {
      background: blendColors(STATUS_CRITICAL, SECONDARY_GLOBAL_HOVER)
    },
    pressed: {
      background: blendColors(STATUS_CRITICAL, SECONDARY_GLOBAL_PRESSED),
    },
    ...AVATAR_FOCUSED,
    ...AVATAR_DISABLED,
  },
  major: {
    container: AVATAR_ORANGE,
    content: AVATAR_CONTENT,
    hovered: {
      background: blendColors(AVATAR_ORANGE, SECONDARY_GLOBAL_HOVER)
    },
    pressed: {
      background: blendColors(AVATAR_ORANGE, SECONDARY_GLOBAL_PRESSED),
    },
    ...AVATAR_FOCUSED,
    ...AVATAR_DISABLED,
  },
  minor: {
    container: AVATAR_YELLOW,
    content: AVATAR_CONTENT,
    hovered: {
      background: blendColors(AVATAR_YELLOW, SECONDARY_GLOBAL_HOVER)
    },
    pressed: {
      background: blendColors(AVATAR_YELLOW, SECONDARY_GLOBAL_PRESSED),
    },
    ...AVATAR_FOCUSED,
    ...AVATAR_DISABLED,
  },
  warning: {
    container: AVATAR_BLUE,
    content: SECONDARY_GLOBAL_BASE,
    hovered: {
      background: blendColors(AVATAR_BLUE, SECONDARY_GLOBAL_HOVER)
    },
    pressed: {
      background: blendColors(AVATAR_BLUE, SECONDARY_GLOBAL_PRESSED),
    },
    ...AVATAR_FOCUSED,
    ...AVATAR_DISABLED,
  },
  cleared: {
    container: STATUS_CLEARED,
    content: AVATAR_CONTENT,
    hovered: {
      background: blendColors(STATUS_CLEARED, SECONDARY_GLOBAL_HOVER)
    },
    pressed: {
      background: blendColors(STATUS_CLEARED, SECONDARY_GLOBAL_PRESSED),
    },
    ...AVATAR_FOCUSED,
    ...AVATAR_DISABLED,
  },
  success: {
    container: AVATAR_GREEN,
    content: AVATAR_CONTENT,
    hovered: {
      background: blendColors(AVATAR_GREEN, SECONDARY_GLOBAL_HOVER)
    },
    pressed: {
      background: blendColors(AVATAR_GREEN, SECONDARY_GLOBAL_PRESSED),
    },
    ...AVATAR_FOCUSED,
    ...AVATAR_DISABLED,
  },
  'non-status': {
    container: AVATAR_LIGHTBLUE,
    content: AVATAR_CONTENT,
    hovered: {
      background: blendColors(AVATAR_LIGHTBLUE, SECONDARY_GLOBAL_HOVER),
      imageBackground: SECONDARY_GLOBAL_HOVER,
    },
    pressed: {
      background: blendColors(AVATAR_LIGHTBLUE, SECONDARY_GLOBAL_PRESSED),
      imageBackground: SECONDARY_GLOBAL_PRESSED,
    },
    ...AVATAR_FOCUSED,
    ...AVATAR_DISABLED,
  },
};

const BADGE = {
  container: STATUS_CRITICAL,
  content: SECONDARY_GLOBAL_BASE,
};
const ICON_BADGE = {
  critical: {
    icon: STATUS_CRITICAL,
  },
  minor: {
    icon: STATUS_MINOR,
  },
  success: {
    icon: BADGE_GREEN,
  },
  fault: {
    icon: BADGE_GREY,
    borderColor: BADGE_GREY,
  },
  'non-status': {
    icon: GLOBAL_TRANSPARENT,
  },
};

const RADIO_BUTTON = {
  LABEL: {
    content: SECONDARY_GLOBAL_TEXT,
    disabled: {
      content: SECONDARY_GLOBAL_DISABLED_TEXT
    }
  },
  ERROR_MESSAGE: {
    content: SECONDARY_GLOBAL_ERROR_TEXT
  },
  checked: {
    icon: RADIOBUTTON_CHECKED,
    background: GLOBAL_TRANSPARENT,
    hover: {
      icon: RADIOBUTTON_CHECKED,
      background: SECONDARY_GLOBAL_HOVER
    },
    disabled: {
      icon: SECONDARY_GLOBAL_DISABLED_CONTENT
    }
  },
  unchecked: {
    icon: SECONDARY_GLOBAL_CONTENT,
    background: GLOBAL_TRANSPARENT,
    hover: {
      icon: SECONDARY_GLOBAL_PRESSED_CONTENT,
      background: SECONDARY_GLOBAL_HOVER
    },
    disabled: {
      icon: SECONDARY_GLOBAL_DISABLED_CONTENT
    }
  },
  focus: {
    border: PRIMARY_GLOBAL_FOCUS
  },
  rippleColor: SECONDARY_GLOBAL_PRESSED
};

const CHECKBOX = {
  LABEL: {
    content: SECONDARY_GLOBAL_TEXT,
    disabled: {
      content: SECONDARY_GLOBAL_DISABLED_TEXT
    }
  },
  ERROR_MESSAGE: {
    content: SECONDARY_GLOBAL_ERROR_TEXT
  },
  checked: {
    icon: CHECKBOX_CHECKED,
    background: GLOBAL_TRANSPARENT,
    hover: {
      icon: CHECKBOX_CHECKED,
      background: SECONDARY_GLOBAL_HOVER
    },
    disabled: {
      icon: SECONDARY_GLOBAL_DISABLED_CONTENT
    }
  },
  indeterminate: {
    icon: CHECKBOX_CHECKED,
    background: GLOBAL_TRANSPARENT,
    hover: {
      icon: CHECKBOX_CHECKED,
      background: SECONDARY_GLOBAL_HOVER
    },
    disabled: {
      icon: SECONDARY_GLOBAL_DISABLED_CONTENT
    }
  },
  unchecked: {
    icon: SECONDARY_GLOBAL_CONTENT,
    background: GLOBAL_TRANSPARENT,
    hover: {
      icon: SECONDARY_GLOBAL_PRESSED_CONTENT,
      background: SECONDARY_GLOBAL_HOVER
    },
    disabled: {
      icon: SECONDARY_GLOBAL_DISABLED_CONTENT
    }
  },
  focus: {
    border: PRIMARY_GLOBAL_FOCUS
  },
  rippleColor: SECONDARY_GLOBAL_PRESSED
};

const LEGEND = {
  content: SECONDARY_GLOBAL_LABEL
};
const CALENDAR = {
  HEADER: {
    background: PRIMARY_GLOBAL_BASE,
    content: PRIMARY_GLOBAL_CONTENT,
    TITLE: {
      background: CALENDAR_RANGE_TITLE,
      content: PRIMARY_GLOBAL_CONTENT
    },
    YEAR: {
      content: PRIMARY_GLOBAL_CONTENT
    },
    error: {
      background: STATUS_CRITICAL,
    }
  },
  YEAR_PICKER: {
    LIST: {
      background: GLOBAL_TRANSPARENT,
    },
    ITEM: {
      background: GLOBAL_TRANSPARENT,
      content: SECONDARY_GLOBAL_LABEL,
      selected: {
        background: GLOBAL_TRANSPARENT,
        content: PRIMARY_GLOBAL_BASE,
      }
    }
  },
  MONTH_TITLE: {
    background: SECONDARY_GLOBAL_BACKGROUND,
    content: SECONDARY_GLOBAL_LABEL
  },
  WEEKDAY: {
    background: SECONDARY_GLOBAL_BACKGROUND,
    content: SECONDARY_GLOBAL_CONTENT
  },
  TIME_PICKER: {
    background: GLOBAL_TRANSPARENT,
  },
  DAY: {
    content: SECONDARY_GLOBAL_CONTENT,
    container: SECONDARY_GLOBAL_BACKGROUND,
    border: GLOBAL_TRANSPARENT,
    rippleColor: SECONDARY_GLOBAL_PRESSED,
    focused: {
      content: SECONDARY_GLOBAL_LABEL,
      container: SECONDARY_GLOBAL_BACKGROUND,
      border: SECONDARY_GLOBAL_FOCUS
    },
    hovered: {
      content: SECONDARY_GLOBAL_LABEL,
      container: SECONDARY_GLOBAL_HOVER
    },
    focusedHovered: {
      content: SECONDARY_GLOBAL_LABEL,
      container: SECONDARY_GLOBAL_HOVER,
      border: SECONDARY_GLOBAL_FOCUS
    },
    selected: {
      content: PRIMARY_GLOBAL_CONTENT,
      container: PRIMARY_GLOBAL_BASE,
      hovered: {
        content: PRIMARY_GLOBAL_CONTENT,
        container: blendColors(PRIMARY_GLOBAL_BASE, PRIMARY_GLOBAL_HOVER)
      },
      focused: {
        content: PRIMARY_GLOBAL_CONTENT,
        container: PRIMARY_GLOBAL_BASE,
        border: SECONDARY_GLOBAL_FOCUS
      },
      focusedHovered: {
        content: PRIMARY_GLOBAL_CONTENT,
        container: blendColors(PRIMARY_GLOBAL_BASE, PRIMARY_GLOBAL_HOVER),
        border: SECONDARY_GLOBAL_FOCUS
      },
    },
    error: {
      content: PRIMARY_GLOBAL_CONTENT,
      container: STATUS_CRITICAL,
      focused: {
        content: PRIMARY_GLOBAL_CONTENT,
        container: STATUS_CRITICAL,
        border: SECONDARY_GLOBAL_FOCUS
      },
      hovered: {
        content: PRIMARY_GLOBAL_CONTENT,
        container: blendColors(STATUS_CRITICAL, PRIMARY_GLOBAL_HOVER)
      },
      focusedHovered: {
        content: PRIMARY_GLOBAL_CONTENT,
        container: blendColors(STATUS_CRITICAL, PRIMARY_GLOBAL_HOVER),
        border: SECONDARY_GLOBAL_FOCUS
      }
    },
    inRange: {
      content: SECONDARY_GLOBAL_LABEL,
      container: LIST_SELECTED,
      focused: {
        content: SECONDARY_GLOBAL_LABEL,
        container: LIST_SELECTED,
        border: SECONDARY_GLOBAL_FOCUS
      },
      hovered: {
        content: SECONDARY_GLOBAL_LABEL,
      },
      focusedHovered: {
        content:SECONDARY_GLOBAL_LABEL,
        border: SECONDARY_GLOBAL_FOCUS
      }
    },
    disabled: {
      content: SECONDARY_GLOBAL_DISABLED_CONTENT,
      container: SECONDARY_GLOBAL_BACKGROUND
    },
  },
  ERROR: {
    content: PRIMARY_GLOBAL_CONTENT,
    container: STATUS_CRITICAL
  }
};

const TOGGLE_SWITCH = {
  primary: {
    ON: {
      track: SWITCH_PRIMARY_ON_TRACK,
      knob: SWITCH_PRIMARY_ON_KNOB,
      hoverBackground: SWITCH_PRIMARY_ON_HOVER,
      pressedBackground: SWITCH_PRIMARY_ON_PRESSED,
      disabledBackground: SWITCH_PRIMARY_ON_DISABLED_KNOB,
    },
    OFF: {
      track: SWITCH_PRIMARY_OFF_TRACK,
      knob: SWITCH_PRIMARY_OFF_KNOB,
      hoverBackground: SWITCH_PRIMARY_OFF_HOVER,
      pressedBackground: SWITCH_PRIMARY_OFF_PRESSED,
      disabledBackground: SWITCH_PRIMARY_OFF_DISABLED_KNOB,
    }
  },
  secondary: {
    ON: {
      track:SWITCH_SECONDARY_ON_TRACK,
      knob: SWITCH_SECONDARY_ON_KNOB,
      hoverBackground: SWITCH_SECONDARY_ON_HOVER,
      pressedBackground: SWITCH_SECONDARY_ON_PRESSED,
      disabledBackground: SWITCH_SECONDARY_ON_DISABLED_KNOB,
    },
    OFF: {
      track: SWITCH_SECONDARY_OFF_TRACK,
      knob: SWITCH_SECONDARY_OFF_KNOB,
      hoverBackground: SWITCH_SECONDARY_OFF_HOVER,
      pressedBackground: SWITCH_SECONDARY_OFF_PRESSED,
      disabledBackground: SWITCH_SECONDARY_OFF_DISABLED_KNOB,
    }
  },
  focusedBackground: PRIMARY_GLOBAL_FOCUS,
  LABEL: {
    content: SECONDARY_GLOBAL_TEXT,
    disabled: {
      content: SECONDARY_GLOBAL_DISABLED_TEXT
    }
  },
};

const DIVIDER = {
  color: SECONDARY_GLOBAL_DIVIDER
};

const DIALOG = {
  title: SECONDARY_GLOBAL_TEXT,
};

const TYPOGRAPHY = {
  content: SECONDARY_GLOBAL_TEXT
};

const EXPANSION_BUTTON = {
  content: SECONDARY_GLOBAL_CONTENT
};

const ALERTS = {
  WARNING: STATUS_MINOR,
  ERROR: STATUS_CRITICAL,
  CONFIRM: PRIMARY_GLOBAL_BASE
};

const DATAGRID = {
  cell: {
    color: SECONDARY_GLOBAL_TEXT,
    normal: {
      border: DATAGRID_DIVIDER,
      background: DATAGRID_BASE,
      hover: {
        background: blendColors(Color(DATAGRID_BASE), Color(DATAGRID_HOVER))
      },
      focus: {
        border: PRIMARY_GLOBAL_FOCUS
      }
    },
    active: {
      background: DATAGRID_SELECTED,
      hover: {
        background: blendColors(Color(DATAGRID_SELECTED), Color(DATAGRID_SELECTED_HOVER))
      },
      focus: {
        border: PRIMARY_GLOBAL_FOCUS,
        background: blendColors(Color(DATAGRID_SELECTED), Color(DATAGRID_SELECTED_FOCUS))
      },
      pressed: {
        border: PRIMARY_GLOBAL_FOCUS,
        background: blendColors(Color(DATAGRID_SELECTED), Color(DATAGRID_SELECTED_PRESSED))
      }
    },
    editable: {
      hover: {
        border: DATAGRID_INPUT_BORDER
      },
      focus: {
        border: PRIMARY_GLOBAL_FOCUS
      }
    },
    error: {
      normal: {
        border: DATAGRID_DIVIDER,
        background: DATAGRID_ERROR_BACKGROUND,
        hover: {
          background: blendColors(Color(DATAGRID_ERROR_BACKGROUND), Color(DATAGRID_HOVER))
        },
        focus: {
          border: PRIMARY_GLOBAL_FOCUS
        }
      },
      active: {
        background: DATAGRID_ERROR_BACKGROUND,
        hover: {
          background: blendColors(Color(DATAGRID_ERROR_BACKGROUND), Color(DATAGRID_HOVER))
        },
        focus: {
          border: STATUS_CRITICAL,
          background: blendColors(Color(DATAGRID_ERROR_BACKGROUND), Color(DATAGRID_HOVER))
        },
        pressed: {
          border: STATUS_CRITICAL,
          background: blendColors(Color(DATAGRID_SELECTED), Color(DATAGRID_SELECTED_PRESSED))
        },
        editing: {
          border: STATUS_CRITICAL,
          background: blendColors(Color(DATAGRID_SELECTED), Color(DATAGRID_SELECTED_HOVER))
        }
      },
      editable: {
        hover: {
          border: STATUS_CRITICAL
        },
        focus: {
          border: STATUS_CRITICAL
        }
      }
    }
  },
  rowDragFloatingCell: {
    border: DATAGRID_PRESSED,
    content: DATAGRID_PRESSED_TEXT,
    background: blendColors(Color(DATAGRID_BASE), Color(DATAGRID_FOCUS))
  },
  icon: {
    color: PRIMARY_GLOBAL_BASE,
    dragIcon: {
      color: DATAGRID_LABEL
    }
  },
  input: {
    background: DATAGRID_BASE,
    border: DATAGRID_DIVIDER,
    color: DATAGRID_INPUT_BORDER
  },
  header: {
    background: DATAGRID_HEADER_BASE,
    border: DATAGRID_DIVIDER,
    color: DATAGRID_LABEL,
    hover: {
      background: DATAGRID_HOVER
    },
    focus: {
      border: PRIMARY_GLOBAL_FOCUS,
      background: DATAGRID_FOCUS
    },
    filtered: {
      color: SECONDARY_GLOBAL_TEXT
    },
    floatingFilter: {
      color: SECONDARY_GLOBAL_TEXT,
      border: PRIMARY_GLOBAL_FOCUS,
    },
    columnMenu: {
      background: DATAGRID_BASE,
      icon: {
        hover: {
          background: blendColors(SECONDARY_GLOBAL_BACKGROUND, SECONDARY_GLOBAL_HOVER)
        }
      }
    }
  }
};

const STATUSBAR = {
  content: SECONDARY_GLOBAL_CONTENT,
  background: DATAGRID_HEADER_BASE,
  border: DATAGRID_DIVIDER,
  input: {
    inactive: {
      border: INPUT_BORDER,
    },
    active: {
      border: STATUSBAR_INPUT_BORDER
    },
    hover: {
      border:  blendColors(SECONDARY_GLOBAL_DIVIDER, INPUT_HOVER),
    },
  }
};
const FAB = {
  medium: {
    background: FAB_PRIMARY_BACKGROUND,
    content: FAB_CONTENT,
    ripple: {
      background: FAB_PRESSED,
    },
    hover: {
      background: blendColors(FAB_PRIMARY_BACKGROUND, FAB_HOVER),
      content: FAB_CONTENT
    },
    focus: {
      border: FAB_PRIMARY_FOCUS,
    },
    keyDown: {
      background: blendColors(FAB_PRIMARY_BACKGROUND, FAB_PRESSED),
    },
    active: {
      background: blendColors(FAB_PRIMARY_BACKGROUND , blendColors(FAB_HOVER, FAB_PRESSED)),
    }
  },
  small: {
    background: FAB_MINI_BACKGROUND,
    content: SECONDARY_GLOBAL_CONTENT,
    ripple: {
      background: SECONDARY_GLOBAL_PRESSED,
    },
    hover: {
      background: blendColors(FAB_MINI_BACKGROUND, SECONDARY_GLOBAL_HOVER),
      content: SECONDARY_GLOBAL_PRESSED_CONTENT
    },
    focus: {
      border: PRIMARY_GLOBAL_FOCUS
    },
    keyDown: {
      background: blendColors(FAB_MINI_BACKGROUND, Color(SECONDARY_GLOBAL_PRESSED))
    },
    active: {
      background: blendColors(Color(FAB_MINI_BACKGROUND), blendColors(Color(SECONDARY_GLOBAL_HOVER), Color(SECONDARY_GLOBAL_PRESSED)))
    }
  }
};

const EXPANSION_PANEL = {
  content: SECONDARY_GLOBAL_TEXT,
  secondaryContent: SECONDARY_GLOBAL_CONTENT,
  background: EXPANSION_PANEL_BASE,
  pressed: EXPANSION_PANEL_PRESSED,
  divider: SECONDARY_GLOBAL_DIVIDER,
  stickyHeader: {
    background: STICKY_HEADER,
    hover: {
      background: STICKY_HEADER_HOVER,
    },
    active: {
      background: STICKY_HEADER_ACTIVE,
    }
  },
  focus: {
    border: PRIMARY_GLOBAL_FOCUS,
    background: EXPANSION_PANEL_BASE,
    hover: {
      border: PRIMARY_GLOBAL_FOCUS,
      background: EXPANSION_PANEL_HOVER,
    }
  },
  hover: {
    border: GLOBAL_TRANSPARENT,
    background: EXPANSION_PANEL_HOVER,
  },
  selected: {
    background: EXPANSION_PANEL_SELECTED,
    hover: {
      background: blendColors(EXPANSION_PANEL_SELECTED, EXPANSION_PANEL_SELECTED_HOVER)
    }
  },
  disabled: {
    background: EXPANSION_PANEL_DISABLED,
    content: SECONDARY_GLOBAL_DISABLED_CONTENT,
  }
};

const CARD = {
  ...ELEVATIONS['2'],
  hover: {
    ...ELEVATIONS['4'],
  },
  focus: {
    border: PRIMARY_GLOBAL_FOCUS
  },
  selected: {
    border: PRIMARY_GLOBAL_BASE
  }
};

const LOGO = {
  color: NOKIA_LOGO_BLUE,
};

const LAUNCHPAD = {
  innerBackground: BACKGROUND_8_DARK,
  TILE: {
    ...ELEVATIONS['2'],

    hover: {
      ...ELEVATIONS['4'],
    },
    focus: {
      border: PRIMARY_GLOBAL_FOCUS
    }
  },
  UAS: { // User account summary,
    content: SECONDARY_GLOBAL_TEXT,
    background: GLOBAL_TRANSPARENT,
    hovered: {
      background: GLOBAL_TRANSPARENT,
      content: SECONDARY_GLOBAL_TEXT
    },
    focused: {
      content: SECONDARY_GLOBAL_TEXT,
      border: PRIMARY_GLOBAL_FOCUS,
    },
    pressed: {
      background: APPBANNER_PRESSED,
    },
  },
};

const TOGGLE_BUTTON_GROUP = {
  ON: {
    background: TOGGLEGROUP_BACKGROUND_ON,
    content: TOGGLEGROUP_CONTENT_ON,
    border: GLOBAL_TRANSPARENT,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS,
    },
    hover: {
      background: blendColors(TOGGLEGROUP_BACKGROUND_ON, TOGGLEGROUP_HOVER_ON),
      content: TOGGLEGROUP_CONTENT_ON,
    },
    focusedHovered: {
      border: PRIMARY_GLOBAL_FOCUS,
      background: blendColors(TOGGLEGROUP_BACKGROUND_ON, TOGGLEGROUP_HOVER_ON),
      content: TOGGLEGROUP_CONTENT_ON
    },
    disabled: {
      background: TOGGLEGROUP_BACKGROUND_ON,
      content: SECONDARY_GLOBAL_DISABLED_CONTENT
    },
    pressed: {
      content: TOGGLEGROUP_CONTENT_PRESSED_ON
    },
    critical: {
      icon: STATUS_CRITICAL_ON
    },
    major: {
      icon: STATUS_MAJOR_ON
    },
    minor: {
      icon: STATUS_MINOR_ON
    },
    warning: {
      icon: STATUS_WARNING_ON
    },
    divider: TOGGLEGROUP_DIVIDER_ON,
  },
  OFF: {
    background: SECONDARY_GLOBAL_BACKGROUND,
    content: TOGGLEGROUP_CONTENT_OFF,
    border: GLOBAL_TRANSPARENT,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS
    },
    hover: {
      background: blendColors(SECONDARY_GLOBAL_BACKGROUND,SECONDARY_GLOBAL_HOVER),
      content: TOGGLEGROUP_CONTENT_PRESSED_OFF
    },
    focusedHovered: {
      border: PRIMARY_GLOBAL_FOCUS,
      background: blendColors(SECONDARY_GLOBAL_BACKGROUND,SECONDARY_GLOBAL_HOVER),
      content: SECONDARY_GLOBAL_LABEL
    },
    disabled: {
      background: SECONDARY_GLOBAL_BACKGROUND,
      content: SECONDARY_GLOBAL_DISABLED_CONTENT
    },
    pressed: {
      content: TOGGLEGROUP_CONTENT_PRESSED_OFF
    },
    critical: {
      icon: STATUS_CRITICAL_OFF
    },
    major: {
      icon: STATUS_MAJOR_OFF
    },
    minor: {
      icon: STATUS_MINOR_OFF
    },
    warning: {
      icon: STATUS_WARNING_OFF
    },
    divider: SECONDARY_GLOBAL_DIVIDER,
  },
  rippleColor: SECONDARY_GLOBAL_PRESSED,
  disabled: {
    critical: {
      icon: STATUS_CRITICAL_DISABLED,
    },
    major: {
      icon: STATUS_MAJOR_DISABLED,
    },
    minor: {
      icon: STATUS_MINOR_DISABLED,
    },
    warning: {
      icon: STATUS_WARNING_DISABLED,
    }
  },
};

const SIGN_IN = {
  ...ELEVATIONS['2'],
  background: BACKGROUND_1,
};

const USER_ACCOUNT_SUMMARY = {
  username: SECONDARY_GLOBAL_TEXT,
  description: SECONDARY_GLOBAL_LABEL,
  ABOUT_PRODUCT: {
    logo: LOGO.color,
    product_name: SECONDARY_GLOBAL_TEXT,
    release: SECONDARY_GLOBAL_LABEL,
    copyright: SECONDARY_GLOBAL_LABEL,
  }
};

const OVERLAY_PANEL = {
  title: SECONDARY_GLOBAL_TEXT,
  divider: OVERLAY_TOP_DIVIDER
};

const CAROUSEL = {
  background: SECONDARY_GLOBAL_DISABLED_CONTENT,
  focus: {
    border: PRIMARY_GLOBAL_FOCUS,
  },
  active: {
    background: PRIMARY_GLOBAL_BASE
  },
  pressed: {
    background: blendColors(Color(PRIMARY_GLOBAL_BASE), Color(PRIMARY_GLOBAL_PRESSED))
  },
  hover: {
    background: SECONDARY_GLOBAL_PRESSED_CONTENT
  }
};

const SLIDER = {
  thumb: {
    color: PRIMARY_GLOBAL_BASE,
    focus: {
      border: PRIMARY_GLOBAL_FOCUS,
    },
    halo: {
      hover: SECONDARY_GLOBAL_HOVER,
      active: SECONDARY_GLOBAL_PRESSED,
    },
    content: {
      normal: SECONDARY_GLOBAL_TEXT,
      tearDrop: PRIMARY_GLOBAL_TEXT,
      tearDropBackground: PRIMARY_GLOBAL_BASE,
      tearDropDisabled: SECONDARY_GLOBAL_DISABLED_CONTENT,
    },
    disabled: SECONDARY_GLOBAL_DISABLED_CONTENT
  },
  label: {
    color: SECONDARY_GLOBAL_TEXT,
    disabled: SECONDARY_GLOBAL_DISABLED_CONTENT,
  },
  track: {
    on: {
      color: PRIMARY_GLOBAL_BASE,
      disabled: SECONDARY_GLOBAL_DISABLED_CONTENT
    },
    off: {
      color: SLIDER_TRACK,
      disabled: SECONDARY_GLOBAL_DISABLED_CONTENT,
    }
  },
};

const LINEAR_PROGRESS_DETERMINATE = {
  text: SECONDARY_GLOBAL_LABEL,
  progressInitialColor: PROGRESS_INDICATOR_DETERMINATE,
  progressFinalColor: PROGRESS_INDICATOR,
  track: PROGRESS_INDICATOR_TRACK,
};

const LINEAR_PROGRESS_INDETERMINATE = {
  progressInitialColor: PROGRESS_INDICATOR_DETERMINATE,
  progressFinalColor: PROGRESS_INDICATOR,
  track: PROGRESS_INDICATOR_TRACK
};

const CIRCULAR_PROGRESS_DETERMINATE = {
  text: SECONDARY_GLOBAL_LABEL,
  progressInitialColor: PROGRESS_INDICATOR_DETERMINATE,
  progressFinalColor: PROGRESS_INDICATOR,
  track: PROGRESS_INDICATOR_TRACK
};

const CIRCULAR_PROGRESS_INDETERMINATE = {
  text: SECONDARY_GLOBAL_LABEL,
  progressInitialColor: PROGRESS_INDICATOR_DETERMINATE,
  progressFinalColor: PROGRESS_INDICATOR,
  track: PROGRESS_INDICATOR_TRACK
};

const CHIP = {
  default: {
    background: CHIP_BASE,
    content: STATUS_CONTENT,
    secondaryContent: STATUS_CONTENT,
    icon: STATUS_CONTENT,
    border: GLOBAL_TRANSPARENT,
    rippleColor: CHIP_PRESSED,
    hovered: {
      background: blendColors(CHIP_BASE, CHIP_HOVER),
      content: STATUS_CONTENT,
      secondaryContent: STATUS_CONTENT,
      icon: STATUS_CONTENT,
      border: GLOBAL_TRANSPARENT
    },
    focused: {
      background: CHIP_BASE,
      content: STATUS_CONTENT,
      secondaryContent: STATUS_CONTENT,
      icon: STATUS_CONTENT,
      border: CHIPS_PRIMARY_FOCUS
    },
    hoveredFocused: {
      background: blendColors(CHIP_BASE, CHIP_HOVER),
      content: STATUS_CONTENT,
      secondaryContent: STATUS_CONTENT,
      icon: STATUS_CONTENT,
      border: CHIPS_PRIMARY_FOCUS
    }
  },
  selected: {
    background: CHIP_SELECTED,
    content: CHIP_CONTENT,
    secondaryContent: CHIP_SECONDARY_CONTENT,
    icon: CHIP_ICON,
    border: GLOBAL_TRANSPARENT,
    rippleColor: CHIP_PRESSED,
    hovered: {
      background: blendColors(CHIP_SELECTED, CHIP_SELECTED_HOVER),
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: GLOBAL_TRANSPARENT
    },
    focused: {
      background: CHIP_SELECTED,
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: CHIPS_PRIMARY_FOCUS
    },
    hoveredFocused: {
      background: blendColors(CHIP_SELECTED, CHIP_SELECTED_HOVER),
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: CHIPS_PRIMARY_FOCUS
    }
  },
  error: {
    background: CHIP_ERROR_BACKGROUND,
    content: CHIP_CONTENT,
    secondaryContent: CHIP_SECONDARY_CONTENT,
    icon: CHIP_ICON,
    border: SECONDARY_GLOBAL_ERROR_TEXT,
    rippleColor: CHIP_PRESSED,
    hovered: {
      background: blendColors(CHIP_ERROR_BACKGROUND, CHIP_HOVER),
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: SECONDARY_GLOBAL_ERROR_TEXT,
    },
    focused: {
      background: CHIP_ERROR_BACKGROUND,
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: CHIPS_PRIMARY_FOCUS,
    },
    hoveredFocused: {
      background: blendColors(CHIP_ERROR_BACKGROUND, CHIP_HOVER),
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: CHIPS_PRIMARY_FOCUS,
    }
  },
  errorSelected: {
    background: CHIP_ERROR_SELECTED_BACKGROUND,
    content: CHIP_CONTENT,
    icon: CHIP_ICON,
    border: SECONDARY_GLOBAL_ERROR_TEXT,
    rippleColor: CHIP_PRESSED,
    hovered: {
      background: blendColors(CHIP_ERROR_SELECTED_BACKGROUND, CHIP_HOVER),
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: SECONDARY_GLOBAL_ERROR_TEXT,
    },
    focused: {
      background: CHIP_ERROR_SELECTED_BACKGROUND,
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: CHIPS_PRIMARY_FOCUS,
    },
    hoveredFocused: {
      background: blendColors(CHIP_ERROR_SELECTED_BACKGROUND, CHIP_HOVER),
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: CHIPS_PRIMARY_FOCUS,
    }
  },
  create: {
    background: CHIP_SELECTED,
    content: CHIP_CONTENT,
    secondaryContent: CHIP_SECONDARY_CONTENT,
    icon: CHIP_ICON,
    border: GLOBAL_TRANSPARENT,
    hovered: {
      background: CHIP_SELECTED,
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: GLOBAL_TRANSPARENT,
    },
    focused: {
      background: CHIP_SELECTED,
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: GLOBAL_TRANSPARENT,
    },
    hoveredFocused: {
      background: CHIP_SELECTED,
      content: CHIP_CONTENT,
      secondaryContent: CHIP_SECONDARY_CONTENT,
      icon: CHIP_ICON,
      border: GLOBAL_TRANSPARENT,
    }
  }
};

const FILTER_FIELD = {
  content: SECONDARY_GLOBAL_LABEL,
  icon: SECONDARY_GLOBAL_CONTENT,
  match: TEXT_SELECTION,
  matchSelected: TEXT_SELECTION_FOCUS,
  filterMatchedText: NOKIA_PURE_TEXT_BOLD,
};
const COACHMARKS = {
  content: SECONDARY_GLOBAL_TEXT,
  count: SECONDARY_GLOBAL_LABEL
};

const INFO_CHIP = {
  info: {
    background: CHIP_INFO,
    content: STATUS_CONTENT,
    icon: STATUS_CONTENT,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS,
    }
  },
  minor: {
    background: STATUS_MINOR,
    content: STATUS_CONTENT,
    icon: STATUS_CONTENT,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS,
    }
  },
  success: {
    background: STATUS_SUCCESS,
    content: STATUS_CONTENT,
    icon: STATUS_CONTENT,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS,
    }
  },
  critical: {
    background: STATUS_CRITICAL,
    content: PRIMARY_GLOBAL_CONTENT,
    icon: PRIMARY_GLOBAL_CONTENT,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS,
    }
  },
  'non-status': {
    background: GLOBAL_TRANSPARENT, // The background of NON STATUS INFO CHIPS can be any _300 library colour @ 38% transparency specified by user.
    content: STATUS_CONTENT,
    icon: STATUS_CONTENT,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS,
    }
  }
};

const FILE_UPLOAD = {
  border: SECONDARY_GLOBAL_PLACEHOLDER,
  background: GLOBAL_TRANSPARENT,
  error: PRIMARY_GLOBAL_ERROR_TEXT,
  primaryContent: SECONDARY_GLOBAL_TEXT,
  secondaryContent: SECONDARY_GLOBAL_LABEL,
  onDrop: {
    icon: PRIMARY_GLOBAL_FOCUS,
    background: FILEUPLOAD_ACTIVE,
    error: {
      icon: STATUS_CRITICAL,
      background: SECONDARY_GLOBAL_DISABLED_BACKGROUND
    }
  }
};

const INLINE_FEEDBACK_MESSAGES = {
  info: {
    background: FEEDBACK_INFO_BACKGROUND,
    icon: PRIMARY_GLOBAL_BASE,
    text: SECONDARY_GLOBAL_PRESSED_CONTENT,
  },
  error: {
    background: FEEDBACK_ERROR_BACKGROUND,
    icon: STATUS_CRITICAL,
    text: SECONDARY_GLOBAL_PRESSED_CONTENT,
  },
  warning: {
    background: FEEDBACK_WARNING_BACKGROUND,
    icon: STATUS_MINOR,
    text: SECONDARY_GLOBAL_PRESSED_CONTENT,
  },
  success: {
    background: FEEDBACK_SUCCESS_BACKGROUND,
    icon: FEEDBACK_SUCCESS,
    text: SECONDARY_GLOBAL_PRESSED_CONTENT,
  },
  overlay: FEEDBACK_OVERLAY,
  hyperlink: FEEDBACK_HYPERLINK,
};

const BREADCRUMBS = {
  title: SECONDARY_GLOBAL_TEXT,
  subtitle: SECONDARY_GLOBAL_CONTENT,
  background: SECONDARY_GLOBAL_BACKGROUND,
  separatorColor: SECONDARY_GLOBAL_DISABLED_CONTENT,
  rippleColor: SECONDARY_GLOBAL_PRESSED,
  focus: {
    border: PRIMARY_GLOBAL_FOCUS,
    background: SECONDARY_GLOBAL_BACKGROUND,
  },
  hover: {
    background: SECONDARY_GLOBAL_HOVER,
  },
  pressed: {
    background: SECONDARY_GLOBAL_PRESSED,
    content: BREADCRUMB_PRESSED_CONTENT,
  }
};

const SEARCH_W_CHIPS =  {
  container: {
    background: SECONDARY_GLOBAL_BASE,
    border: TOGGLEGROUP_DIVIDER_ON,
    focused: {
      border: PRIMARY_GLOBAL_FOCUS
    },
    hover: {
      border: blendColors(TOGGLEGROUP_DIVIDER_ON, INPUT_HOVER)
    },
    error: {
      border: SECONDARY_GLOBAL_ERROR_TEXT
    }
  },
  subField: {
    normal: {
      background: GLOBAL_TRANSPARENT,
      content: SECONDARY_GLOBAL_TEXT,
    },
    active: {
      background: QUERY_BACKGROUND_ON,
      content: SECONDARY_GLOBAL_TEXT
    },
    hover: {
      background: QUERY_BACKGROUND_FOCUS,
      content: SECONDARY_GLOBAL_TEXT
    },
    focused: {
      background: QUERY_BACKGROUND_FOCUS,
      content: SECONDARY_GLOBAL_TEXT
    },
  },
  globalLogic: {
    ON: {
      background: TOGGLE_BACKGROUND_ON,
      content: TOGGLE_CONTENT_ON,
      border: GLOBAL_TRANSPARENT,
      focused: {
        border: PRIMARY_GLOBAL_FOCUS,
      },
      hover: {
        background: blendColors(TOGGLE_BACKGROUND_ON, PRIMARY_GLOBAL_HOVER),
        content: PRIMARY_GLOBAL_CONTENT,
      },
      focusedHovered: {
        border: PRIMARY_GLOBAL_FOCUS,
        background: blendColors(TOGGLE_BACKGROUND_ON, PRIMARY_GLOBAL_HOVER),
        content: PRIMARY_GLOBAL_FOCUS
      },
      disabled: {
        background: TOGGLE_BACKGROUND_ON,
        content: SECONDARY_GLOBAL_DISABLED_CONTENT
      },
      pressed: {
        content: PRIMARY_GLOBAL_CONTENT
      }
    },
    OFF: {
      background: OR_TOGGLE_BACKGROUND,
      content: TOGGLEGROUP_CONTENT_ON,
      border: GLOBAL_TRANSPARENT,
      focused: {
        border: PRIMARY_GLOBAL_FOCUS
      },
      hover: {
        background: blendColors(TOGGLEGROUP_BACKGROUND_ON, TOGGLE_GROUP_HOVER_ON),
        content: TOGGLEGROUP_CONTENT_ON,
      },
      focusedHovered: {
        border: PRIMARY_GLOBAL_FOCUS,
        background: SECONDARY_GLOBAL_HOVER,
        content: blendColors(TOGGLEGROUP_BACKGROUND_ON, TOGGLE_GROUP_HOVER_ON)
      },
      disabled: {
        background: SECONDARY_GLOBAL_BACKGROUND,
        content: SECONDARY_GLOBAL_DISABLED_CONTENT
      },
      pressed: {
        content: TOGGLEGROUP_CONTENT_PRESSED_ON
      }
    },
    rippleColor: blendColors(TOGGLEGROUP_BACKGROUND_ON, PRIMARY_GLOBAL_PRESSED),
    containerBackground: GLOBAL_TRANSPARENT,
  },
  operator: {
    default: {
      background: GLOBAL_TRANSPARENT,
      content: EXPRESSION_NORMAL,
      hovered: {
        background: GLOBAL_TRANSPARENT,
        content: EXPRESSION_NORMAL,
      },
      focused: {
        background: GLOBAL_TRANSPARENT,
        content: EXPRESSION_FOCUS,
      },
      hoveredFocused: {
        background: GLOBAL_TRANSPARENT,
        content: EXPRESSION_FOCUS,
      }
    },
    selected: {
      background: GLOBAL_TRANSPARENT,
      content: EXPRESSION_NORMAL,
      hovered: {
        background: GLOBAL_TRANSPARENT,
        content: EXPRESSION_NORMAL,
      },
      focused: {
        background: GLOBAL_TRANSPARENT,
        content: EXPRESSION_FOCUS,
      },
      hoveredFocused: {
        background: GLOBAL_TRANSPARENT,
        content: EXPRESSION_FOCUS,
      }
    },
  },
  icon: SECONDARY_GLOBAL_CONTENT,
  morebutton: {
    content: STATUS_CONTENT,
    hovered: {
      content: STATUS_CONTENT,
    },
    selected: {
      content: CHIP_ICON,
      hovered: {
        content: CHIP_ICON,
      }
    },
  },
};

const STATUS_INDICATOR = {
  cleared: {
    background: STATUS_CLEARED,
    content: STATUS_CONTENT,
    icon: STATUS_CONTENT
  },
  warning: {
    background: STATUS_WARNING,
    content: STATUS_CONTENT,
    icon: STATUS_CONTENT
  },
};

const SNACKBAR = {
  background: SNACKBAR_BACKGROUND,
  content: SNACKBAR_TEXT,
  hyperlink: SNACKBAR_HYPERLINK,
  progressInitialColor: SNACKBAR_PROGRESS_INDICATOR_DETERMINATE,
  progressFinalColor: SNACKBAR_PROGRESS_INDICATOR,
};

const UTILITY_DRAWER = {
  content: SECONDARY_GLOBAL_LABEL,
};

const CLIWINDOW = {
  text: CLI_TEXT,
  background: CLI_BACKGROUND,
  selectedBackground: CLI_BACKGROUND_TEXT,
  cursor: CLI_CURSOR,
  icon: CLI_ICON,
};

const FLOATING_PANEL = {
  divider: SECONDARY_GLOBAL_DIVIDER,
  TYPOGRAPHY: {
    content: SECONDARY_GLOBAL_LABEL
  }
};

const STEP_FORM = {
  BUTTON: {
    warning: {
      icon: STATUS_CONTENT,
      background: STEPFORM_WARNING,
      text: SECONDARY_GLOBAL_BASE,
      disabled: STEPFORM_DISABLED_WARNING_ICON,
    },
    error: {
      icon: SECONDARY_GLOBAL_BASE,
      background: STEPFORM_ERROR_ICON,
      text: SECONDARY_GLOBAL_BASE,
      disabled: STEPFORM_DISABLED_ERROR_ICON,
      pressedIcon: STEPFORM_PRESSED_ERROR_ICON,
    },
    current: {
      icon: STEPFORM_ACTIVE,
      background: STEPFORM_SELECTED_BACKGROUND,
      text:   PRIMARY_GLOBAL_TEXT,
    },
    completed: {
      icon: STEPFORM_ACTIVE,
      text: SECONDARY_GLOBAL_TEXT,
      disabled: STEPFORM_COMPLETED_DISABLED,
    },
    futureLinear: {
      text: SECONDARY_GLOBAL_DISABLED_CONTENT,
      border: SECONDARY_GLOBAL_DISABLED_CONTENT,
      background: GLOBAL_TRANSPARENT,
    },
    future: {
      text: SECONDARY_GLOBAL_DISABLED_CONTENT,
      border: SECONDARY_GLOBAL_DISABLED_CONTENT,
      borderNonLinear: STEPFORM_ACTIVE,
      background: GLOBAL_TRANSPARENT,
    },
    disabled: {
      text: SECONDARY_GLOBAL_DISABLED_CONTENT,
      border: SECONDARY_GLOBAL_DISABLED_CONTENT,
      background: GLOBAL_TRANSPARENT,
    }
  },
  SUBSTEP: {
    current: {
      background: STEPFORM_ACTIVE,
      text: SECONDARY_GLOBAL_CONTENT,
      currentBackground: STEPFORM_SELECTED_BACKGROUND,
    },
    completed: {
      background: STEPFORM_ACTIVE,
      disabled: STEPFORM_COMPLETED_DISABLED,
    },
    future: {
      background: GLOBAL_TRANSPARENT,
      border: STEPFORM_ACTIVE,
    },
    warning: {
      background: STEPFORM_WARNING,
      disabled: STEPFORM_DISABLED_WARNING_ICON,
    },
    error: {
      background: STEPFORM_ERROR_ICON,
      disabled: STEPFORM_DISABLED_ERROR_ICON,
    },
    disabled: {
      border: SECONDARY_GLOBAL_DISABLED_CONTENT,
      background: GLOBAL_TRANSPARENT,
    },
    pressed: {
      text: STEPFORM_PRESSED_TEXT,
    },
  },
  TITLE: {
    current: {
      text: STEPFORM_SELECTED_TEXT,
    },
    disabled: {
      text: SECONDARY_GLOBAL_DISABLED_CONTENT,
    },
    futureLinear: {
      text: SECONDARY_GLOBAL_DISABLED_CONTENT,
    },
    pressed: {
      text: STEPFORM_PRESSED_TEXT,
    },
    text: STEPFORM_TEXT,
  },
  DETAIL: {
    current: {
      text: SECONDARY_GLOBAL_CONTENT,
    },
    disabled: {
      text: SECONDARY_GLOBAL_DISABLED_CONTENT,
    },
    futureLinear: {
      text: SECONDARY_GLOBAL_DISABLED_CONTENT,
    },
    pressed: {
      text: STEPFORM_PRESSED_TEXT,
    },
    text: SECONDARY_GLOBAL_CONTENT
  },
  divider: SECONDARY_GLOBAL_DIVIDER,
  text: SECONDARY_GLOBAL_TEXT,
  detailText: SECONDARY_GLOBAL_CONTENT,
  pressedText: STEPFORM_PRESSED_TEXT,
  icon: SECONDARY_GLOBAL_CONTENT,
  background: STEPFORM_BASE,
  selected: {
    background: STEPFORM_SELECTED_BACKGROUND,
    focused: {
      background: STEPFORM_SELECTED_BACKGROUND,
    },
    hovered: {
      background: blendColors(STEPFORM_SELECTED_BACKGROUND, STEPFORM_SELECTED_HOVER),
    },
    pressed: {
      background: blendColors(STEPFORM_PRESSED, STEPFORM_SELECTED_HOVER),
    }
  },
  pressed: {
    background: STEPFORM_PRESSED,
    hovered: {
      background: blendColors(STEPFORM_PRESSED, STEPFORM_HOVER)
    },
  },
  disabled: {
    icon: SECONDARY_GLOBAL_DISABLED_CONTENT,
    text: SECONDARY_GLOBAL_DISABLED_CONTENT
  },
  focused: {
    background: STEPFORM_BASE,
    border: PRIMARY_GLOBAL_FOCUS
  },
  hovered: {
    background: STEPFORM_HOVER,
    focused: {
      background: STEPFORM_HOVER,
    }
  },
  error: {
    background: STEPFORM_ERROR_BACKGROUND,
    text: SECONDARY_GLOBAL_PRESSED_CONTENT,
    hovered: {
      background: blendColors(STEPFORM_ERROR_BACKGROUND, STEPFORM_HOVER),
      focused: {
        background: blendColors(STEPFORM_ERROR_BACKGROUND, STEPFORM_HOVER),
      }
    },
    pressed: {
      background: blendColors(STEPFORM_ERROR_BACKGROUND, STEPFORM_PRESSED),
      hovered: {
        background: blendColors(STEPFORM_ERROR_BACKGROUND, STEPFORM_PRESSED),
      },
    }
  },
  scrollButton: {
    background: ELEVATIONS['1'].darkBackgroundColor,
  },
};

const SPLITSCREEN = {
  resizer: {
    background: SECONDARY_GLOBAL_DIVIDER,
    hover: {
      background: SECONDARY_GLOBAL_PRESSED
    },
    pressed: {
      background: SECONDARY_GLOBAL_PRESSED
    }
  },
};

const SKELETON = {
  baseColor: SKELETON_BASE,
  highlightColor: SKELETON_GRADIENT,
  icon: SECONDARY_GLOBAL_PLACEHOLDER
};

export default {
  NAME,
  GLOBAL_CCFK_STYLE,
  BUTTON,
  BREADCRUMBS,
  ICON,
  ICON_BUTTON,
  ELEVATIONS,
  APP_BANNER,
  APP_BANNER_INTERACTIVE_CONTENT,
  TOOLTIP,
  TOGGLE_SWITCH,
  HORIZONTAL_NAVIGATION,
  HORIZONTAL_NAVIGATION_TAB,
  TOOLBAR,
  LIST,
  TREE,
  TEXT_INPUT,
  TEXT_AREA,
  HYPERLINK,
  AVATAR,
  BADGE,
  ICON_BADGE,
  RADIO_BUTTON,
  EXPANSION_PANEL,
  LEGEND,
  TOGGLE_BUTTON_GROUP,
  CHECKBOX,
  DATAGRID,
  CALENDAR,
  DIVIDER,
  DIALOG,
  TYPOGRAPHY,
  ALERTS,
  EXPANSION_BUTTON,
  STATUSBAR,
  FAB,
  CARD,
  LOGO,
  LAUNCHPAD,
  SIGN_IN,
  USER_ACCOUNT_SUMMARY,
  OVERLAY_PANEL,
  CAROUSEL,
  SLIDER,
  CHIP,
  INFO_CHIP,
  FILTER_FIELD,
  LINEAR_PROGRESS_DETERMINATE,
  LINEAR_PROGRESS_INDETERMINATE,
  CIRCULAR_PROGRESS_DETERMINATE,
  CIRCULAR_PROGRESS_INDETERMINATE,
  COACHMARKS,
  SEARCH_W_CHIPS,
  FILE_UPLOAD,
  INLINE_FEEDBACK_MESSAGES,
  SNACKBAR,
  STATUS_INDICATOR,
  UTILITY_DRAWER,
  CLIWINDOW,
  FLOATING_PANEL,
  SPLITSCREEN,
  STEP_FORM,
  SKELETON
};